import React, { useEffect, useRef, useState } from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { getIcon } from '../../../helpers/icons';
import { Button } from '../../../components/Field';
import { getSiteAttr } from '../../../helpers/storage';
import Logout from './Logout';
import MobileMenu from './MobileMenu';
import CalcHeight from '../CalcHeight';
import Link from '../../../components/Link';
import Center from '../../../components/Center';
import ProfileImage from '../../Shared/ProfileImage';
import Background from "../../../components/Background";
import useOutsideClick from '../../../hooks/useOutSideClick';
import WithPermission from '../../Shared/WithPermission';
import Notification from '../Notification';

import style from './style.module.css';


let logoutTimer = null;
export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMenuListOpen, setIsMenuListOpen] = useState(false);
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const navigate = useNavigate();
    const headerRef = useRef(null);
    const dropdownRef = useRef(null);
    const notificationRef = useRef(null);
    const [popup, setPopup] = useState(false);
    const userData = useSelector((state) => get(state, 'storage.data'));
    const { fullname, id } = userData
    const { pathname } = useLocation();

    useEffect(() => {
        setIsMenuListOpen(false);
    }, [pathname])

    useOutsideClick(dropdownRef, () => {
        if (isMenuOpen) setIsMenuOpen(false);
    });

    useOutsideClick(notificationRef, () => {
        if (isNotificationOpen) setIsNotificationOpen(false);
    });

    if (!id) {
        return <></>;
    }

    const menuItem = [
        { id: "dashboard", path: '/dashboard', label: 'Dashboard', permissionText: 'Dashboard List' },
        { id: "yourclients", path: '/quotes', label: 'Your Clients', permissionText: ["Quote List", "Policy List"] },
        { id: "renewals", path: '/renewals', label: 'Renewals', permissionText: 'Renewal List' },
        { id: "transaction", path: '/transaction', label: 'Accounts', permissionText: 'Transaction List' },
        { id: "quote", path: '/quote', label: 'Get Quote', permissionText: 'Quote List' }
    ];
    const drobDownItems = [
        { text: fullname, agency: get(userData, 'agency.name'), icon: "User", link: "/my-profile", className: style.userLink },
        { text: "My account", icon: "Setting", link: "/my-profile" },
        { text: "Get Quote", icon: "Page", link: "/quote", className: style.quoteLink },
        {
            text: "Logout",
            icon: "Logout",
            link: "#",
            onClick: () => {
                setIsMenuOpen(false);
                clearTimeout(logoutTimer);
                logoutTimer = setTimeout(() => {
                    setPopup('logout');
                }, 401);
            }
        },
    ];

    if (get(userData, 'access_level') === 'super_broker') {
        drobDownItems.push({ text: "Manage Broking House", icon: "Network", link: "/manage-agency", className: style.agentLink });
    }

    const toggleMenu = () => setIsMenuOpen((prev) => !prev);
    const toggleMenuList = () => setIsMenuListOpen((prev) => !prev);
    const toggleNotification = () => setIsNotificationOpen((prev) => !prev);
    const isSearchOpen = pathname === "/search";
    const handleSearch = () => {
        navigate(isSearchOpen ? "/dashboard" : "/search")
    };
    const isActive = (id, path) => {
        return pathname === path || (id === 'yourclients' && ['/quotes', '/policies', '/policy'].some(p => pathname.startsWith(p)));
    };
    const menuForNavbar = menuItem.filter(item => item.id !== 'quote');

    return (
        <>
            <div className={style.headerNav} ref={headerRef}>
                <div className={style.navbar}>
                    <Center>
                        <div className={style.nabarContainer}>
                            <Link to="/dashboard" className={style.logo}>
                                <Background src={getSiteAttr('image')} normalImage={true} />
                            </Link>
                            <div className={style.quoteSection}>
                                <div className={style.quote}>
                                    <Button link="/quote" className={style.quoteBtn} label="Get Quote" color="orange" size="medium" />
                                </div>
                                <div ref={dropdownRef}>
                                    <Link className={`${style.userMenu} ${isMenuOpen ? style.toggleMenu : ''}`} onClick={toggleMenu}>
                                        <div className={style.userImg}>
                                            <ProfileImage />
                                        </div>
                                        <span className={`${style.dropdownIcon}`}>
                                            <i className={getIcon("Triange")} />
                                        </span>
                                    </Link>
                                    <div className={`${style.drobDownItems} ${isMenuOpen ? style.activeMenu : ''}`}>
                                        {drobDownItems.map((item, index) => (
                                            <Link
                                                key={index}
                                                onClick={() => {
                                                    if (item.onClick) {
                                                        item.onClick();
                                                    } else {
                                                        setIsMenuOpen(false);
                                                    }
                                                }}
                                                className={get(item, 'className') || ""}
                                                to={get(item, 'link')}
                                            >
                                                <div>
                                                    <p className={style.userName}>{get(item, 'text')}</p>
                                                    {get(item, 'agency') && <p className={style.agentName}>{get(item, 'agency')}</p>}
                                                </div>
                                                <div className={style.drobIcon}>
                                                    <i className={getIcon(get(item, 'icon'))} />
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Center>
                </div>
                <div className={style.navbarMenu}>
                    <Center>
                        <div className={style.navbarMenuContainer}>
                            <div className={style.menuContainer}>
                                <div className={`${style.menuLinks}`}>
                                    {
                                        menuForNavbar.map((ele) => {
                                            return (
                                                <WithPermission key={get(ele, 'id', '')} permission={get(ele, 'permissionText', '')}>
                                                    <Link
                                                        key={get(ele, 'id', '')}
                                                        to={get(ele, 'path', '#')}
                                                        className={isActive(get(ele, 'id', ''), get(ele, 'path', '')) ? style.isActive : style.nonActive}
                                                    >
                                                        {get(ele, 'label', '')}
                                                    </Link>
                                                </WithPermission>
                                            )
                                        })
                                    }
                                </div>
                                <Link className={style.bar} onClick={toggleMenuList}>
                                    <span><i className={getIcon(isMenuListOpen ? "Close" : "Bars")} /></span>
                                </Link>
                            </div>
                            <div className={style.menuIcons} ref={notificationRef}>
                                <div className={style.search}>
                                    <Link onClick={handleSearch} className={`${style.icon} ${isSearchOpen ? style.active : ``}`}>
                                        <i className={getIcon(isSearchOpen ? "Close" : "Search")} />
                                    </Link>
                                </div>
                                <WithPermission permission="Notification List">
                                    {
                                        <Notification
                                            toggleNotification={toggleNotification}
                                            isNotificationOpen={isNotificationOpen}
                                        />
                                    }

                                </WithPermission>
                            </div>
                        </div>
                    </Center>
                </div>
                <MobileMenu
                    isMenuListOpen={isMenuListOpen}
                    setIsMenuListOpen={setIsMenuListOpen}
                    menuItem={menuItem}
                    isActive={isActive}
                />
            </div>
            {fullname && <CalcHeight headerRef={headerRef} />}
            {popup === "logout" && <Logout onClose={() => setPopup(false)} />}
        </>
    )
}